module.exports = __webpack_public_path__ + "img/jobsmedia.8b6d22a6.png";